// src/components/ui/Badge.jsx
import React from "react";

/**
 * Pill badge. Variants:
 *   - "gold" | "teal" | "red" | "blue" | "neutral" | "success" (solid green)
 */
export default function Badge({
  children,
  variant = "gold",
  icon = null,
  className = "",
}) {
  const variants = {
    gold:
      "bg-[var(--gold-dim)] text-[var(--gold-lt)] border-[var(--gold-border)]",
    teal:
      "bg-[var(--teal-dim)] text-[var(--teal)] border-[var(--teal-border)]",
    red:
      "bg-[var(--red-dim)] text-[var(--red)] border-[var(--red-border)]",
    blue:
      "bg-[var(--blue-dim)] text-[var(--blue)] border-[var(--blue-border)]",
    neutral:
      "bg-[var(--surf-2)] text-[var(--txt-2)] border-[var(--border-2)]",
    success:
      "bg-[var(--teal)] text-white border-[var(--teal)] font-semibold",
  }[variant];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[11px] font-medium whitespace-nowrap ${variants} ${className}`}
    >
      {icon && (
        <i
          className={`ti ti-${icon}`}
          style={{ fontSize: "11px", lineHeight: 1 }}
        />
      )}
      {children}
    </span>
  );
}
